<template>
	<div id="lastCheckResult" class="subscription-and-forms">
		<div v-if="isGoodCandidate" class="candidate">
			<div class="left-sec">
				<img src="/img/saving_cta.svg" class="saving" />
			</div>
			<div class="right-sec">
				<div class="header2">You are throwing your money away!</div>
				<div class="paragraph">
					Our review of your neighborhood and the comparable homes near you indicates that your property is a good candidate for an
					assessment appeal. Our analysis indicates you can save up to {{ property.savingAmount | toCurrency }} a year. We strongly suggest
					you file an appeal to contest your assessment. Garbur has several options to help you with your appeal and save you money. Click
					Next to find out more. The deadline to file an appeal for your township is approaching.
				</div>
				<div class="candidate-form-sec">
					<div class="paragraph">Would you like to take the next step?</div>
					<Button title="Next Step" :onClick="nextSteps" />
				</div>
			</div>
		</div>
		<div v-else class="not-candidate">
			<img v-if="!showSubscriedMsg" src="/img/not_saving_cta.svg" class="not-saving" />

			<div v-if="!showSubscriedMsg" class="right-sec">
				<div class="header2">{{ header }}</div>
				<div class="paragraph">{{ paragraph }}</div>
				<div v-if="showSubscribe" class="form-section">
					<InputBox placeHolder="Full Name" v-model="form.fullName" />
					<InputBox placeHolder="Email *" v-model="form.email" />
					<Button title="Subscribe" :onClick="submit" />
				</div>
			</div>
			<div v-else class="thanks-note">
				<div class="header2">Thank you for subscribing! We will be in touch!</div>
			</div>
		</div>
	</div>
</template>

<script>
import InputBox from "@/components/ui/InputBox.vue";
import Button from "@/components/ui/Button.vue";
import { AUTH_SUB } from "@/store/constants";
import { assessmentStatus } from "@/env";

export default {
	name: "subscription-and-forms",
	data: function () {
		return {
			showSubscriptionModal: false,
			showToastAlert: false,
			showSubscriedMsg: false,
			form: {
				fullName: "",
			},
			header: "",
			paragraph: "",
			showSubscribe: true,
			propertyURL: "",
		};
	},
	components: {
		InputBox,
		Button,
	},
	mounted() {
		this.showSubscriedMsg = false;
		this.getClassCodeMsgs();

		// get property URL for subscription email
		this.propertyURL = window.location.href;
	},
	computed: {
		isGoodCandidate() {
			return this.$store.getters.getAssessmentRate === assessmentStatus.overAssessed; //"Overassessed";
		},
		isNotAssessed() {
			return this.$store.getters.getAssessmentRate === assessmentStatus.notAssessed; //"Not Assessed";
		},
		property() {
			return this.$store.getters.getAllPropertyData;
		},
	},
	methods: {
		getClassCodeMsgs() {
			const classCode = Number(this.property.propertyClassification);
			switch (true) {
				case classCode == 0:
				case classCode == 100:
				case classCode == 200:
				case classCode == 201:
				case classCode == 219:
				case classCode == 225:
				case classCode == 241:
				case classCode == 290:
				case classCode == 297:
					this.header = "This property is currently not part of Garbur’s tax analysis system.  Please check back later for updates.";
					this.showSubscribe = false;
					break;
				case classCode == 299:
					this.header = `This property is a residential condominium unit.  In Cook County condominiums
            are best appealed through your condominium association.
            If you would like Garbur to assist your condominium association in filing an appeal
            please contact us at 847-790-5029 or via email at info@garbur.com.`;

					this.showSubscribe = false;
					break;
				case classCode >= 300:
					this.header = `This is a commercial property.  Garbur does not currently have an automated analysis tool for commercial properties.
            Please contact us at (847)790-5028 or via email at info@garbur.com for more information of commercial property tax appeals.`;
					this.showSubscribe = false;
					break;
				default:
					this.showSubscribe = true;
					if (this.isNotAssessed) {
						this.header = "We don't have enough information";
						this.paragraph = `We can contact you in the future when reasessement happens or Check back here when you get reassessed.`;
					} else {
						this.header = "You are in good shape!";
						this.paragraph = `Our review of your neighborhood and the comparable homes near you indicates that your property assessment is in line with your
            		neighbors. Even though this means you are not a good candidate for an assessment appeal, it does mean that your taxes are in line
            		with your neighbors and you have not been over paying compared to your neighborhood.`;
					}
			}
		},
		nextSteps() {
			this.$router.push({ name: "Filing Options" });
		},
		openSubscriptionModal() {
			this.showSubscriptionModal = true;
		},
		isFormValid() {
			if (!this.form.email) {
				return false;
			}
			return true;
		},
		async submit() {
			if (!this.isFormValid()) {
				this.$toast.open({
					message: "Missing email!",
					position: "top",
					type: "error",
				});
			} else {
				this.showSubscriptionModal = false;
				this.showToastAlert = true;
				const user = {
					fullName: this.form.fullName,
					email: this.form.email,
					propertyId: this.$route.params.id,
					propertyURL: this.propertyURL,
				};
				try {
					const result = await this.$store.dispatch(AUTH_SUB, user);
					if (result) this.setSubscribeTrue();
				} catch (ex) {
					this.$toast.open({
						message: "Error happened when submitting subscribtion",
						position: "top",
						type: "error",
					});
				}
			}
		},
		setSubscribeTrue() {
			this.form = {
				fullName: "",
			};
			this.showSubscriedMsg = true;
		},
		reset() {
			console.log("reset");
		},
	},
};
</script>

<style lang="scss">
.subscription-and-forms {
	margin-top: 130px;
	max-width: 1600px;
	margin: 0 auto;
	.header2 {
		font-size: 51px;
		text-align: center;
		color: var(--primary);
		margin-bottom: 30px;
		line-height: 107%;
		text-align: left;
	}
	.paragraph {
		text-align: left;
		margin-bottom: 15px;
	}
	.input-box {
		.input-cont input {
			border: 1px solid #c4c4c4;
		}
	}
	.not-saving {
		display: grid;
		align-self: center;
		justify-self: center;
	}
	.thanks-note {
		display: grid;
		grid-column: span 2;
		justify-content: center;
	}
	.not-candidate,
	.candidate {
		display: grid;
		grid-gap: 40px;
		// grid-template-columns: repeat(auto-fit, minmax(415px, 1fr));
		grid-template-columns: 1fr 2fr;
		margin-top: 50px;
	}
	.candidate {
		.paragraph {
			margin-bottom: unset;
		}
	}
	.candidate-form-sec {
		display: flex;
		margin-top: 30px;
		justify-content: space-evenly;
	}
	.left-sec {
		display: flex;
		align-items: center;
		justify-content: center;
		img.saving {
			width: 25rem;
			height: auto;
		}
	}
}
@media screen and (max-width: 980px) {
	.subscription-and-forms {
		.not-candidate,
		.candidate {
			grid-template-columns: repeat(auto-fit, minmax(415px, 1fr));
		}
		.not-saving {
			display: grid;
			align-self: center;
			justify-self: center;
		}
	}
}
@media screen and (max-width: 414px) {
	.subscription-and-forms {
		padding: 3rem 1rem;
		.not-candidate,
		.candidate {
			display: grid;
			grid-gap: 40px;
			// grid-template-columns: repeat(auto-fit, minmax(372px, 1fr));
			grid-template-columns: 1fr;
		}
		.left-sec img.saving,
		img.not-saving {
			width: 20rem;
		}
		.right-sec .header2 {
			font-size: 2rem;
		}
	}
}
</style>
